import React, { useEffect, useState } from 'react';
import config from '../config';

function Companias() {
  const [companias, setCompanias] = useState([]);
  const [form, setForm] = useState({ 
    nombre: '', 
    api_url: '', 
    api_token: '', 
    username: '', 
    password: '',
    correos: []
  });
  const [mensaje, setMensaje] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [editingCompania, setEditingCompania] = useState(null);
  const [search, setSearch] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 8;

  const token = localStorage.getItem('token');

  const fetchCompanias = async () => {
    try {
      console.log('Iniciando fetch de compañías...');
      console.log('Token:', token ? 'Presente' : 'Ausente');
      
      if (!token) {
        console.error('No hay token disponible');
        setMensaje('No hay token de autenticación');
        setCompanias([]);
        return;
      }
      
      const res = await fetch(`${config.API_BASE_URL}/api/companias`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      
      console.log('Status de respuesta:', res.status);
      
      if (res.status === 401) {
        console.error('Token inválido o expirado');
        setMensaje('Sesión expirada. Por favor, inicia sesión nuevamente.');
        setCompanias([]);
        return;
      }
      
      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }
      
      const data = await res.json();
      console.log('Datos recibidos:', data);
      console.log('Tipo de datos:', typeof data);
      console.log('Es array?', Array.isArray(data));
      
      // Inspeccionar la estructura de correos en los datos
      if (Array.isArray(data)) {
        data.forEach((compania, index) => {
          console.log(`Compañía ${index + 1}:`, {
            id: compania.id,
            nombre: compania.nombre,
            correos: compania.correos,
            tipoCorreos: typeof compania.correos
          });
        });
      }
      
      // Protección para asegurar que companias sea siempre un array
      if (Array.isArray(data)) {
        console.log('Estableciendo compañías como array:', data);
        setCompanias(data);
      } else if (data && Array.isArray(data.companias)) {
        console.log('Estableciendo compañías desde propiedad:', data.companias);
        setCompanias(data.companias);
      } else {
        console.error('Respuesta inesperada del backend:', data);
        setCompanias([]);
      }
    } catch (err) {
      console.error('Error al cargar compañías:', err);
      setMensaje('Error al cargar compañías');
      setCompanias([]);
    }
  };

  useEffect(() => {
    fetchCompanias();
    // eslint-disable-next-line
  }, []);

  // Función auxiliar para parsear correos de forma segura
  const parseCorreosSafely = (correosData) => {
    try {
      // Si ya es un array, retornarlo directamente
      if (Array.isArray(correosData)) {
        return correosData;
      }
      
      // Si es un string, intentar parsearlo
      if (correosData && typeof correosData === 'string') {
        const parsed = JSON.parse(correosData);
        if (Array.isArray(parsed)) {
          return parsed;
        }
      }
      
      // Si es un objeto pero no un array, podría ser un correo único
      if (correosData && typeof correosData === 'object') {
        return [correosData];
      }
      
      return [];
    } catch (error) {
      console.error('Error parseando correos:', error, 'Datos:', correosData);
      return [];
    }
  };

  // Funciones para manejar correos
  const addCorreo = () => {
    setForm(prev => ({
      ...prev,
      correos: [...prev.correos, {
        host: '',
        port: 993,
        secure: true,
        user: '',
        password: '',
        isOffice365: false
      }]
    }));
  };

  const removeCorreo = (index) => {
    setForm(prev => ({
      ...prev,
      correos: prev.correos.filter((_, i) => i !== index)
    }));
  };

  const updateCorreo = (index, field, value) => {
    setForm(prev => ({
      ...prev,
      correos: prev.correos.map((correo, i) => 
        i === index ? { ...correo, [field]: value } : correo
      )
    }));
  };

  const handleEdit = (compania) => {
    setEditingCompania(compania);
    setForm({
      nombre: compania.nombre || '',
      api_url: compania.api_url || '',
      api_token: compania.api_token || '',
      username: compania.username || '',
      password: compania.password || '',
      correos: parseCorreosSafely(compania.correos)
    });
    setShowModal(true);
  };

  const handleAdd = async (e) => {
    e.preventDefault();
    setMensaje('');
    try {
      const res = await fetch(`${config.API_BASE_URL}/api/companias`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(form)
      });
      if (res.ok) {
        setForm({ nombre: '', api_url: '', api_token: '', username: '', password: '', correos: [] });
        setShowModal(false);
        setEditingCompania(null);
        fetchCompanias();
        setMensaje('Compañía agregada correctamente');
      } else {
        const data = await res.json();
        setMensaje(data.message || 'Error al agregar compañía');
      }
    } catch (err) {
      setMensaje('Error de conexión');
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    setMensaje('');
    try {
      const res = await fetch(`${config.API_BASE_URL}/api/companias/${editingCompania.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(form)
      });
      if (res.ok) {
        setForm({ nombre: '', api_url: '', api_token: '', username: '', password: '', correos: [] });
        setShowModal(false);
        setEditingCompania(null);
        fetchCompanias();
        setMensaje('Compañía actualizada correctamente');
      } else {
        const data = await res.json();
        setMensaje(data.message || 'Error al actualizar compañía');
      }
    } catch (err) {
      setMensaje('Error de conexión');
    }
  };

  const handleSubmit = editingCompania ? handleUpdate : handleAdd;

  // Filtro y paginación con protección adicional
  const filtered = Array.isArray(companias) ? companias.filter(c => c.nombre.toLowerCase().includes(search.toLowerCase())) : [];
  const totalPages = Math.ceil(filtered.length / pageSize);
  const paginated = filtered.slice((currentPage - 1) * pageSize, currentPage * pageSize);

  return (
    <div className="container-fluid">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4 className="fw-bold" style={{ color: 'var(--color-texto)' }}>Listado de Compañías</h4>        
      </div>
      
      <div className="card shadow-sm border-0" style={{ padding: 20 }}>
        <div className="card-body p-0">
          <div className="row mb-3">
            <div className="col-md-4">
              <input type="text" className="form-control" placeholder="Buscar compañía..." value={search} onChange={e => setSearch(e.target.value)} style={{ color: '#6c757d', borderColor: '#e5e8eb', borderRadius: '0.25rem' }} />
            </div>
            <div className="col-md-4">
            </div>
            <div className="col-md-4">
              <button className="btn" style={{ background: 'var(--color-principal)', color: '#fff', borderRadius: '0.25rem', fontWeight: 500, float: 'right' }} onClick={() => setShowModal(true)}>
                + Agregar Compañía
              </button>
            </div>
          </div>
          <table className="table hyper-table align-middle mb-0" style={{ minWidth: 900 }}>
            <thead style={{ background: '#f4f6f8', borderBottom: '2px solid #e9ecef' }}>
              <tr>
                <th style={{ color: 'var(--color-texto)', width: 60, fontWeight: 700, fontSize: 15 }}>#</th>
                <th style={{ color: 'var(--color-texto)', fontWeight: 700, fontSize: 15 }}>Nombre</th>
                <th style={{ color: 'var(--color-texto)', fontWeight: 700, fontSize: 15 }}>API URL</th>
                <th style={{ color: 'var(--color-texto)', fontWeight: 700, fontSize: 15 }}>API Token</th>
                <th style={{ color: 'var(--color-texto)', fontWeight: 700, fontSize: 15 }}>Username</th>
                <th style={{ color: 'var(--color-texto)', fontWeight: 700, fontSize: 15 }}>Password</th>
                <th style={{ color: 'var(--color-texto)', fontWeight: 700, fontSize: 15 }}>Correos</th>
                <th style={{ color: 'var(--color-texto)', fontWeight: 700, fontSize: 15 }}>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {paginated.length === 0 ? (
                <tr><td colSpan={8} className="text-center text-muted">No hay compañías</td></tr>
              ) : (
                paginated.map((c, i) => (
                  <tr key={c.id} style={{ borderBottom: '1px solid #f0f1f3' }}>
                    <td style={{ color: 'var(--color-texto)', fontWeight: 500 }}>{(currentPage - 1) * pageSize + i + 1}</td>
                    <td style={{ color: 'var(--color-texto)' }}>{c.nombre}</td>
                    <td style={{ color: 'var(--color-texto)' }}>{c.api_url}</td>
                    <td style={{ color: 'var(--color-texto)' }}>{c.api_token}</td>
                    <td style={{ color: 'var(--color-texto)' }}>{c.username}</td>
                    <td style={{ color: 'var(--color-texto)' }}>{c.password}</td>
                                         <td style={{ color: 'var(--color-texto)' }}>
                       {(() => {
                         const correos = parseCorreosSafely(c.correos);
                         if (correos.length > 0) {
                           return (
                             <div>
                               {correos.map((correo, idx) => (
                                 <div key={idx} className="mb-1">
                                   <small className="text-muted">
                                     {correo.user}@{correo.host || 'N/A'}
                                     {correo.isOffice365 && <span className="badge bg-primary ms-2">O365</span>}
                                   </small>
                                 </div>
                               ))}
                             </div>
                           );
                         }
                         return <span className="text-muted">Sin correos</span>;
                       })()}
                     </td>
                    <td>
                      <button 
                        className="btn btn-sm btn-outline-primary me-2"
                        onClick={() => handleEdit(c)}
                        title="Editar"
                      >
                        <i className="bi bi-pencil"></i>
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
      {/* Paginación */}
      {totalPages > 1 && (
        <nav className="mt-3">
          <ul className="pagination justify-content-end">
            {Array.from({ length: totalPages }, (_, idx) => (
              <li key={idx} className={`page-item${currentPage === idx + 1 ? ' active' : ''}`}>
                <button className="page-link" style={{ color: 'var(--color-principal)', border: 'none', background: 'none' }} onClick={() => setCurrentPage(idx + 1)}>{idx + 1}</button>
              </li>
            ))}
          </ul>
        </nav>
      )}
      {/* Modal para agregar/editar compañía */}
      {showModal && (
        <div className="modal fade show" style={{ display: 'block', background: 'rgba(0,0,0,0.2)' }} tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {editingCompania ? 'Editar Compañía' : 'Agregar Compañía'}
                </h5>
                <button type="button" className="btn-close" onClick={() => {
                  setShowModal(false);
                  setEditingCompania(null);
                  setForm({ nombre: '', api_url: '', api_token: '', username: '', password: '', correos: [] });
                }}></button>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="modal-body">
                  <div className="mb-3">
                    <label className="form-label">Nombre</label>
                    <input type="text" className="form-control" value={form.nombre} onChange={e => setForm({ ...form, nombre: e.target.value })} required autoFocus />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">API URL</label>
                    <input type="text" className="form-control" value={form.api_url} onChange={e => setForm({ ...form, api_url: e.target.value })} required />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">API Token</label>
                    <input type="text" className="form-control" value={form.api_token} onChange={e => setForm({ ...form, api_token: e.target.value })} required />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Username</label>
                    <input type="text" className="form-control" value={form.username} onChange={e => setForm({ ...form, username: e.target.value })} required />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Password</label>
                    <input type="password" className="form-control" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} required />
                  </div>
                  
                  {/* Sección de Correos */}
                  <div className="mb-3">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <label className="form-label mb-0">Configuración de Correos</label>
                      <button 
                        type="button" 
                        className="btn btn-sm btn-outline-primary"
                        onClick={addCorreo}
                      >
                        <i className="bi bi-plus"></i> Agregar Correo
                      </button>
                    </div>
                    
                    {form.correos.length === 0 ? (
                      <div className="text-muted text-center py-3 border rounded">
                        No hay correos configurados
                      </div>
                    ) : (
                      form.correos.map((correo, index) => (
                        <div key={index} className="border rounded p-3 mb-3">
                          <div className="d-flex justify-content-between align-items-center mb-2">
                            <h6 className="mb-0">Correo {index + 1}</h6>
                            <button 
                              type="button" 
                              className="btn btn-sm btn-outline-danger"
                              onClick={() => removeCorreo(index)}
                            >
                              <i className="bi bi-trash"></i>
                            </button>
                          </div>
                          
                          <div className="row">
                            <div className="col-md-6 mb-2">
                              <label className="form-label small">Host</label>
                              <input 
                                type="text" 
                                className="form-control form-control-sm" 
                                placeholder="mail.cuidacasa.com"
                                value={correo.host} 
                                onChange={e => updateCorreo(index, 'host', e.target.value)} 
                                required 
                              />
                            </div>
                            <div className="col-md-3 mb-2">
                              <label className="form-label small">Puerto</label>
                              <input 
                                type="number" 
                                className="form-control form-control-sm" 
                                placeholder="993"
                                value={correo.port} 
                                onChange={e => updateCorreo(index, 'port', parseInt(e.target.value))} 
                                required 
                              />
                            </div>
                            <div className="col-md-3 mb-2">
                              <label className="form-label small">Seguro</label>
                              <select 
                                className="form-select form-select-sm" 
                                value={correo.secure} 
                                onChange={e => updateCorreo(index, 'secure', e.target.value === 'true')} 
                                required
                              >
                                <option value={true}>Sí</option>
                                <option value={false}>No</option>
                              </select>
                            </div>
                            <div className="col-md-3 mb-2">
                              <label className="form-label small">Office 365</label>
                              <select 
                                className="form-select form-select-sm" 
                                value={correo.isOffice365 ? 'true' : 'false'} 
                                onChange={e => updateCorreo(index, 'isOffice365', e.target.value === 'true')} 
                              >
                                <option value={false}>No</option>
                                <option value={true}>Sí</option>
                              </select>
                            </div>
                          </div>
                          
                          <div className="row">
                            <div className="col-md-6 mb-2">
                              <label className="form-label small">Usuario</label>
                              <input 
                                type="text" 
                                className="form-control form-control-sm" 
                                placeholder="imaiberica@cuidacasa.com"
                                value={correo.user} 
                                onChange={e => updateCorreo(index, 'user', e.target.value)} 
                                required 
                              />
                            </div>
                            <div className="col-md-6 mb-2">
                              <label className="form-label small">Contraseña</label>
                              <input 
                                type="password" 
                                className="form-control form-control-sm" 
                                placeholder="Contraseña del correo"
                                value={correo.password} 
                                onChange={e => updateCorreo(index, 'password', e.target.value)} 
                                required 
                              />
                            </div>
                          </div>
                        </div>
                      ))
                    )}
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => {
                    setShowModal(false);
                    setEditingCompania(null);
                    setForm({ nombre: '', api_url: '', api_token: '', username: '', password: '', correos: [] });
                  }}>Cancelar</button>
                  <button type="submit" className="btn" style={{ background: 'var(--color-principal)', color: '#fff', borderRadius: '2rem', fontWeight: 500 }}>
                    {editingCompania ? 'Actualizar' : 'Agregar'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
      {/* Mensaje de éxito/error */}
      {mensaje && (
        <div className="alert alert-info position-fixed bottom-0 end-0 m-4" style={{ zIndex: 9999, minWidth: 250 }}>
          {mensaje}
          <button type="button" className="btn-close float-end" style={{ fontSize: 12 }} onClick={() => setMensaje('')}></button>
        </div>
      )}
    </div>
  );
}

export default Companias; 